<template>
  <div
    class="task-upload-file-list"
    :class="{ 'task-upload-file-list--scrollable': scrollable }"
    data-testid="task-upload-file-list"
  >
    <div
      v-for="(file, index) in files"
      :key="`${file.name}-${index}`"
      class="task-upload-file-list__row"
      :data-testid="`task-upload-file-list__row-${index}`"
    >
      <span
        class="task-upload-file-list__badge"
        :class="`task-upload-file-list__badge--${getBadgeVariant(file)}`"
        :data-testid="`task-upload-file-list__badge-${index}`"
      >
        {{ getFileExtension(file) }}
      </span>

      <span class="task-upload-file-list__name" :data-testid="`task-upload-file-list__name-${index}`">
        {{ file.name }}
      </span>

      <span class="task-upload-file-list__timestamp" :data-testid="`task-upload-file-list__timestamp-${index}`">
        {{ formatTimestamp(file) }}
      </span>

      <button
        type="button"
        class="task-upload-file-list__remove-btn"
        aria-label="Remove file"
        :data-testid="`task-upload-file-list__remove-${index}`"
        @click="$emit('remove', index)"
      >
        <v-icon small>mdi-close</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
import './TaskUploadFileList.scss';
import { getDisplayFileExtension, getFileBadgeVariant } from '@/modules/financialclose/utils/utils';

export default {
  name: 'TaskUploadFileList',

  props: {
    files: {
      type: Array,
      default: () => [],
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getFileExtension(file) {
      return getDisplayFileExtension(file?.name);
    },

    getBadgeVariant(file) {
      return getFileBadgeVariant(this.getFileExtension(file));
    },

    formatTimestamp(file) {
      const date = file.lastModified ? new Date(file.lastModified) : new Date();
      return this.$nova.formatDateTime(date, 'D MMM YYYY, h:mm A');
    },
  },
};
</script>
